<template>
  <div class="coins">
    <div class="content" ref="content">
      <div class="content-box">
        <top-header :isCoins="isCoins"></top-header>
        <top-banner></top-banner>
        <div class="step-box">
          <div class="select-game select-product-box">
            <user-info v-if="isLogin" class="user-info"></user-info>
            <coins-info-card v-if="isLogin"></coins-info-card>
            <select-role v-else></select-role>
            <select-paytype
              v-if="showChannel"
              :isCoins="isCoins"
            ></select-paytype>
          </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
    <service-icon-btn
      v-show="gameId"
      :serverId="pcServerId"
      :roleId="roleId"
      :roleName="roleName"
      :gameId="gameId"
      :isUidLogin="isUidLogin"
      :uid="uid"
      :loginAccount="loginAccount"
    ></service-icon-btn>
    <transition name="fade" mode="out-in">
      <Loading v-show="loading"></Loading>
    </transition>
  </div>
</template>

<script>
import TopBanner from '@components/officialStore/TopBanner.vue';
import TopHeader from '@components/officialStore/TopHeader.vue';
import SelectProduct from '@components/officialStore/product/SelectProduct.vue';
import ServiceIconBtn from '@components/officialStore/ServiceIcon.vue';
import SelectPaytype from '@components/officialStore/paytype/SelectPaytype.vue';
import PageFooter from '@components/officialStore/PageFooter.vue';
import SelectRole from '@components/officialStore/login/SelectRole.vue';
import Loading from '@components/officialStore/Loading.vue';
import UserInfo from '@components/officialStore/login/UserInfo.vue';
import CoinsInfoCard from '@components/officialStore/coins/CoinsInfoCard.vue';
import { mapState } from 'vuex';
import {
  GET_BALANCE_INIT_DATA,
  GET_BALANCE_USER_DATA
} from '@store/officialStore/coins';
import userStatus from '@mixins/officialStore/userStatus';
import {
  storeProductParam,
  getCurLocation
} from '@store/officialStore/storager.js';
import globalConfig from '@utiles/officialStore/globalConfig.js';

export default {
  name: 'webStorePage',
  mixins: [userStatus],
  data() {
    return {
      isCoins: true
    };
  },
  computed: {
    ...mapState({
      isLogin: state => state.login.isLogin,
      loading: state => state.loading,
      showChannel: state => state.showChannel,
      gameId: state => state.gameId,
      pcServerId: state => state.pcServerId,
      roleName: state => state.roleName,
      loginAccount: state => state.login.loginAccount,
      uid: state => state.login.uid,
      isUidLogin: state => state.login.isUidLogin,
      serverId: state => state.serverId,
      roleId: state => state.roleId
    })
  },
  components: {
    TopBanner,
    TopHeader,
    SelectProduct,
    ServiceIconBtn,
    PageFooter,
    SelectPaytype,
    SelectRole,
    Loading,
    UserInfo,
    CoinsInfoCard,
    ThemeConfig: () => import('@components/officialStore/ThemeConfig.vue')
  },
  watch: {
    isLogin(newVal) {
      this.$route.name === 'coins' && this.initCoin(newVal);
    },
    // 在储值页选择角色后，重新储值化代币信息
    roleId(newVal) {
      this.$route.name === 'coins' &&
        this.initCoin(newVal != -1 && newVal != null && newVal != undefined);
    }
  },
  methods: {
    // 用户代币初始化
    async initCoin(bool) {
      if (bool) {
        storeProductParam({
          gameId: this.gameId,
          serverId: this.pcServerId,
          roleId: this.roleId,
          roleName: this.roleName,
          packageName: globalConfig.getHrefParam('packageName'),
          userId: this.uid,
          devicePlate: globalConfig.getHrefParam('devicePlate'),
          location: getCurLocation() || '',
          appLanguage: this.$store.state.lang,
          language: this.$store.state.lang
        });
        await this.$store.dispatch(GET_BALANCE_INIT_DATA);
        await this.$store.dispatch(GET_BALANCE_USER_DATA, {
          useDefaultCurrency: true
        });
      }
    }
  },
  // 有keep-alive缓存组件，改周期函数只会执行一次
  created() {
    this.initCoin(this.isLogin);
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.coins {
  float: left;
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  min-height: 100%;
  background-position: top center;
  background-color: #111114;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
  @psetbg ("bg.png", false,false);
}

.content {
  position: relative;
  margin-bottom: 200px;
}
.content-box {
  position: relative;
  padding-top: 1px;
  font-size: 0;
}
.step-box {
  position: relative;
  box-sizing: border-box;
  text-align: left;
  transition: all 0.6s;
}
.user-info {
  margin-left: 64px;
  margin-bottom: 48px;
}

::v-deep(.section-title-wrap) {
  margin-top: 0;
}

@media screen and (orientation: landscape) {
  .step-box {
    width: 1202px;
    margin: 0 auto;
    padding: 0;
  }

  .bg {
    background-size: auto;
    background-repeat: repeat-y !important;
    @psetbg ("bg-hen.png", false,false);
  }

  .user-info {
    margin-top: 22px;
  }
}
</style>
